import { useMutation } from '@tanstack/react-query';
import { projectService } from '@services/project';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import { getErrorMessage } from '@utils/errorMessage';
import { useTranslation } from '@hooks/useTranslation';

interface UpdateProjectStatusPayload {
  projectId: string;
  status: string;
}

export const useUpdateStatusProject = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['updateProjectStatus'],
    mutationFn: async (payload: UpdateProjectStatusPayload) => {
      return await projectService.updateProjectStatus(
        payload.projectId,
        payload.status,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
      toast.success(tActionMessages.projectStatusUpdatedSuccessfully);
    },
    onError: (error: any) => {
      toast.error(getErrorMessage(error, 'Failed to update project status'));
    },
  });
};

export default useUpdateStatusProject;
